// Generated by CoffeeScript 2.7.0
var BatchAssigmentOverlay;

import {
  newConfirm
} from 'trunks/vue/admin/components/libs/confirm.js';

import {
  newAssignmentSettingsModal
} from 'trunks/vue/admin/compositions/yet_another_workflow/assignment_settings_modal.js';

import Assignment from 'trunks/vue/admin/compositions/yet_another_workflow/assignment.js';

import BatchAssignmentsMixin from 'trunks/controllers/share/assignment.js';

import {
  newSpinner
} from 'trunks/vue/admin/components/spinner.js';

export default BatchAssigmentOverlay = Vue.extend({
  mixins: [BatchAssignmentsMixin],
  components: {
    'assignment': Assignment
  },
  template: `<div
  class="batch-assignment-overlay overlay assignment-overlay"
  :class="{ open: isOpen }"
  ref="overlay"
>
  <div class="content" ref="container">
    <div class="overlay-header">
      <div class="overlay-title">
        <span>批量处理</span>
      </div>
      <div class="closer" @click="close">
        <i class="slp-times"></i>
      </div>
    </div>
    <div class="batch-assignment-overlay-tip">
      <span class="error-text text-normal">您现在对流程进行批量处理，请谨慎操作！</span>
    </div>
    <div class="flow-wrapper">
      <div class="flow-fields-content">
        <div class="responses-content">
          <div v-if="!showComments" class="blankslate">
            <i class="slp-list-pencil-square-o"></i>
            <p>暂无填写内容</p>
          </div>
          <assignment
            v-show="showComments"
            ref="assignmentVm"
            :assignment="assignment"
            :currentVertex="currentVertex"
          />
        </div>
        <div class="flow-footer justify-between">
          <div class="left">
            <div class="assignment-operations">
              <button class="mr-4" @click="approveEvent">批量通过</button>
              <button
                class="mr-4 link-btn btn-danger"
                @click="refuseEvent"
              >
                批量回退
              </button>
              <button
                class="mr-4 link-btn btn-default"
                @click="transferEvent"
              >
                批量转交
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>`,
  props: {
    assignmentAttributes: {
      type: Array
    },
    currentVertexAttributes: {
      type: Object
    },
    currentVertex: {
      type: Skylark.App.Model.YetAnotherWorkflow.Vertex
    }
  },
  data: function() {
    return {
      isOpen: true,
      settingModal: null
    };
  },
  computed: {
    operations: function() {
      return this.currentVertexAttributes.operations;
    },
    assignment: function() {
      var assignment;
      // 构造一个通用的 assignment
      assignment = _.extend(this.currentVertexAttributes, {
        response: {
          id: _.now(),
          entries: this.assignmentAttributes[0].response.entries
        }
      });
      return new Skylark.App.Model.YetAnotherWorkflow.Assignment(assignment);
    },
    assignments: function() {
      return _.map(this.assignmentAttributes, function(assignment) {
        return new Skylark.App.Model.YetAnotherWorkflow.Assignment(assignment);
      });
    },
    showComments: function() {
      return this.currentVertex.dig('operations', 'comment', 'enabled') || this.assignment.fields.length;
    }
  },
  methods: {
    open: function() {
      this.isOpen = true;
      return this._enableBackdrop();
    },
    close: function() {
      this.isOpen = false;
      Skylark.Helpers.App.removeCapturedBackdropByID(this._backdropId);
      this._backdropId = null;
      this.confirm = null;
      return this.settingModal = null;
    },
    approveEvent: function() {
      var assignment_data, promises;
      if (this.requesting) {
        return;
      }
      this._openSpinner();
      this.action = 'approve';
      this.requestCount = 0;
      assignment_data = this.$refs.assignmentVm.getRequestData();
      if (!assignment_data) {
        return;
      }
      promises = _.map(this.assignments, (assignment) => {
        var data, entries;
        entries = this._generateEntries(assignment.response.entries, assignment_data.response_attributes.entries_attributes);
        data = {
          ...assignment_data,
          response_attributes: {
            entries_attributes: entries
          }
        };
        return this._doRequest(_.extend(data, {
          operation: 'route'
        }), assignment, this._afterRoute);
      });
      return this._handlerPromises(promises);
    },
    refuseEvent: function() {
      if (this.requesting) {
        return;
      }
      this.action = 'refuse';
      if (this._settingEnabledByCurrentVertex()) {
        return this._openSettingModal();
      } else {
        if (this.confirm) {
          return;
        }
        this.confirm = this._actionConfirm();
        this.confirm.$on('ensureClicked', () => {
          var assignment_data, promises;
          assignment_data = this.$refs.assignmentVm.getRequestData(false);
          this.confirm = null;
          if (!assignment_data) {
            return;
          }
          assignment_data = _.extend({}, assignment_data, {
            operation: this.action,
            comment: this.$refs.assignmentVm.getCommentData()
          });
          this._openSpinner();
          promises = _.map(this.assignments, (assignment) => {
            return this._doRequest(assignment_data, assignment, this._afterRequest);
          });
          return this._handlerPromises(promises);
        });
        return this.confirm.$on('afterClosed', () => {
          return this.confirm = null;
        });
      }
    },
    updateSetting: function(options) {
      return _.extend(this, options);
    },
    _enableBackdrop: function() {
      var container;
      container = this.$refs.container;
      return this._backdropId = Skylark.Helpers.App.capturedBackdrop((event) => {
        return this.close();
      }, container);
    },
    _doRequest: function(assignment_data = {}, assignment, callback) {
      this._clearErrors();
      this.requesting = true;
      return new Promise((resolve, reject) => {
        return Skylark.Libs.Ajax.patch(this._generateResquestUrl(assignment), {
          responseType: 'json',
          contentType: 'application/json; charset=utf-8',
          data: {
            assignment: assignment_data
          },
          success: (data, xhr) => {
            var new_response;
            resolve();
            if (data.dig('assignment', 'response')) {
              new_response = new Skylark.App.Model.Response(data.assignment.response);
              this.$refs.assignmentVm.updateAssignmentReponse(new_response);
            }
            return typeof callback === "function" ? callback(data) : void 0;
          },
          error: (xhr, status, error) => {
            var error_message;
            reject();
            switch (error.type) {
              case 'user_input':
                error_message = this._parseErrors(error.errors);
                return this._requestAlertify(error_message || `${this.operations[this.action].name}失败`, 'error');
              case 'comment':
                error_message = error.errors.base;
                return this._requestAlertify(error_message || `${this.operations[this.action].name}失败`, 'error');
              case 'remind_frequently':
                error_message = this._parseErrors(error.errors);
                return this._requestAlertify(error_message, 'success');
              default:
                return this._displayError(error);
            }
          },
          complete: () => {
            this.requesting = false;
            return this.requestCount += 1;
          }
        });
      });
    },
    _afterRoute: function(data) {
      if (this._settingEnabled(data)) {
        return this._openSettingModal(data);
      } else {
        if (this.requestCount !== this.assignments.length - 1) {
          return;
        }
        this.confirm = this._actionConfirm();
        this.confirm.$on('ensureClicked', () => {
          var assignment_data, promises;
          this.confirm = null;
          this.requestCount = 0;
          assignment_data = {
            operation: this.action,
            next_vertex_id: data.next_vertices[0].id,
            comment: this.$refs.assignmentVm.getCommentData()
          };
          this._openSpinner();
          promises = _.map(this.assignments, (assignment) => {
            return this._doRequest(assignment_data, assignment, this._afterRequest);
          });
          return this._handlerPromises(promises);
        });
        return this.confirm.$on('afterClosed', () => {
          return this.confirm = null;
        });
      }
    },
    _openSettingModal: function(data) {
      if (this.settingModal) {
        this.settingModal.updateSetting({
          nextVertices: this._sortVertexlist((data != null ? data.next_vertices : void 0) || []),
          nextGraphs: this._formatGraphs((data != null ? data.next_graphs : void 0) || []),
          actionText: this.operations[this.action].name,
          isTransferSetting: Boolean(this.action === 'transfer'),
          isRefuseSetting: Boolean(this.action === 'refuse')
        });
        return this.settingModal.open();
      } else {
        this.settingModal = new newAssignmentSettingsModal({
          currentVertex: this.currentVertex,
          nextVertices: this._sortVertexlist((data != null ? data.next_vertices : void 0) || []),
          nextGraphs: this._formatGraphs((data != null ? data.next_graphs : void 0) || []),
          actionText: this.operations[this.action].name,
          isTransferSetting: Boolean(this.action === 'transfer'),
          isRefuseSetting: Boolean(this.action === 'refuse'),
          journey: data != null ? data.assignment.journey : void 0
        });
        return this.settingModal.$on('ensureClicked', (setting_data) => {
          var assignment_data, promises;
          assignment_data = _.extend(setting_data, this.$refs.assignmentVm.getRequestData(false), {
            operation: this.action,
            comment: this.$refs.assignmentVm.getCommentData()
          });
          promises = _.map(this.assignments, (assignment) => {
            return this._doRequest(assignment_data, assignment, this._afterRequest);
          });
          return this._handlerPromises(promises);
        });
      }
    },
    _displayError: function(error) {
      return newConfirm({
        icon: '<i class="slp-warning-circle-o"></i>',
        title: error.errors.base,
        message: '',
        confirmButtonText: "我知道了",
        cancelButtonText: '',
        type: 'danger'
      }).$on('ensureClicked', this._afterConfirmError);
    },
    _afterConfirmError: function(error) {
      var url;
      switch (error.type) {
        case 'flow_unavailable': // 被删除或停用
          url = Skylark.Helpers.UrlHelper.namespaceUrlFor('yet_another_workflow/flows?category=processed');
          return location.replace(url); // dead_end 异常 || assignment_has_been_processed 已被处理
        default:
          return location.reload();
      }
    },
    _settingEnabledByCurrentVertexBaseJudgement: function() {
      return this.currentVertex.dig('settings', 'carbon_copy', 'enable_manual') || this.currentVertex.dig('operations', 'esignature', 'enabled');
    },
    _actionConfirm: function() {
      return newConfirm({
        title: `是否${this.operations[this.action].name}？`,
        message: '',
        confirmButtonText: "确认"
      });
    },
    _sortVertexlist: function(vertices) {
      return vertices.sort(function(a, b) {
        return a.name.localeCompare(b.name, 'zh-Hans-CN', {
          sensitivity: 'accent'
        });
      });
    },
    _requestSpinner: function() {
      return newSpinner({
        parent: this.$el
      });
    },
    _handlerPromises: function(promises) {
      return Promise.all(promises).then(() => {
        return this.spinner.close();
      }).catch(() => {
        return this.spinner.close();
      });
    },
    _openSpinner: function() {
      if (this.spinner) {
        return this.spinner.open();
      } else {
        return this.spinner = this._requestSpinner();
      }
    }
  }
});
